/**
 * IDIOMA · Catálogo español. Es el ORIGINAL, no una traducción.
 *
 * Las claves se agrupan por dónde se ven (`conn.*`, `perfil.*`…), no por lo que
 * significan. Es a propósito: quien traduce necesita saber si algo es un botón
 * de dos palabras o un párrafo de ayuda, y el prefijo lo dice sin abrir el
 * juego. Agruparlas por tema (`errores.*`) mezcla un rótulo de tres letras con
 * un texto legal.
 *
 * ## Convenciones (ver docs/IDIOMA.md)
 *
 *  - **Botones y rótulos, en MAYÚSCULAS y sin punto final.** Es el estilo del
 *    juego y hay 165 cadenas así; cambiarlo sería otro trabajo.
 *  - **Frases completas, con punto final.** Hoy conviven 85 con punto y 124 sin
 *    él; las que se vayan migrando se normalizan aquí.
 *  - **Tildes siempre**, también en mayúsculas (CONEXIÓN, no CONEXION).
 *  - **Nada de concatenar frases en el código.** Una frase partida en trozos no
 *    se puede traducir: en otro idioma el orden de las partes cambia. Si hace
 *    falta un hueco, se pone un marcador `{así}`.
 *
 * ## Glosario decidido
 *
 *  - **sala** es el sitio donde se juega con otros; **partida** es lo que dura
 *    un marcador. No son sinónimos y no se intercambian.
 *  - **nick** es el permanente y único; **nombre** es el visible y cambiable.
 *  - **disco** es la ficha que se mueve; **jugador** es la persona.
 *  - **cancha**, **patada**, **portería**, **invitado**: sin sinónimo. No se
 *    usan campo, disparo, arco ni anónimo.
 */
export const ES = {
  /* ---------------- estado de conexión (UX-2) ---------------- */
  "conn.conectando": "CONECTANDO…",
  "conn.reconectando": "RECONECTANDO…",
  "conn.reconectandoIntento": "RECONECTANDO… ({intento})",
  "conn.sinConexion": "SIN CONEXIÓN",
  "conn.expulsado": "DESCONECTADO DE LA SALA",
  "conn.restablecida": "CONEXIÓN RESTABLECIDA",
  "conn.reintentar": "REINTENTAR",
  "conn.sincronizando": "SINCRONIZANDO CON EL SERVIDOR…",
  // La cuenta atrás y el "vuelves solo" van JUNTOS en una sola clave: partidos
  // en dos trozos, un idioma que ordene distinto no los podría recomponer.
  "conn.reinicioUno": "REINICIO DEL SERVIDOR EN {n}s · VUELVES SOLO",
  "conn.reinicioOtros": "REINICIO DEL SERVIDOR EN {n}s · VUELVES SOLO",
  "conn.reiniciando": "REINICIANDO SERVIDOR · VUELVES SOLO",
} as const;
